var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sticky-top"},[_c('BaseLogoBar'),(_vm.user === null)?_c('div',[_c('BreadCrumb')],1):_vm._e()],1),_c('div',{staticClass:"d-flex",attrs:{"id":"wrapper"}},[_c('div',{attrs:{"id":"page-content-wrapper"}},[_c('div',{staticClass:"page-shell"},[_c('router-view')],1)])]),_c('BaseFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }